import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';


@Component({
  selector: 'ngbaddtests',
  templateUrl: './addtests.modal.html',
  styleUrls: ['./addtests.modal.scss']
})

export class NgbAddTestsModal implements OnInit {
 
  @Input() ActivityCode: number;
  @Input() CycleCode: number;
   
  public ShowList: boolean = true;
  constructor(public activeModal: NgbActiveModal) { }
  ngOnInit() {



  }
 
 
  onSubmit() {

  }
  ModalClose() {
    this.activeModal.close();
  }

 
  
}
